import { Link } from '@tanstack/react-router'
import { cn } from '../../lib/cn'
import { Crest } from './Crest'
import { PRODUCT_LONG_NAME, PRODUCT_NAME } from '../../lib/product'

/**
 * Crest + wordmark, linking home. The long name sits under the short one in
 * letterspaced caps — brass-deep, since it is 8.5px text (see Eyebrow).
 */
export function Brandlock({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={cn('flex items-center gap-3 rounded-club-sm', className)}
      aria-label={`${PRODUCT_LONG_NAME} — home`}
    >
      <Crest className="size-[38px] shrink-0" />
      <span className="font-display text-[19px] font-semibold leading-tight tracking-[0.01em] text-pine">
        {PRODUCT_NAME}
        <small className="mt-px block font-text text-[8.5px] font-semibold uppercase tracking-[0.28em] text-brass-deep">
          {PRODUCT_LONG_NAME}
        </small>
      </span>
    </Link>
  )
}
